import React, { useContext, useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import XMLViewer from "react-xml-viewer";
import LoadingComponent from "../../../app/layout/LoadingComponent";

interface IProps {
  id: string;
}

const XML: React.FC<IProps> = ({ id }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    xml,
    getUBLById,
    getUBLB64ById,
    getAttachDocumentB64,
    loadXML,
  } = rootStore.invoiceStore;
  useEffect(() => {
    getUBLById(id);
  }, [getUBLById, id]);

  const downloadHandle = () => {
    getUBLB64ById(id);
  };

  const downloadAttachDocumentHandle = () => {
    getAttachDocumentB64();
  };
  if (!loadXML) {
    return <LoadingComponent content="Cargando XML" />;
  }
  return (
    <div>
      <Button
        color="blue"
        onClick={downloadHandle}
        disabled={xml === null ? true : false}
      >
        <Icon name="download" /> Descargar
      </Button>
      <Button
        color="blue"
        onClick={downloadAttachDocumentHandle}
      >
        <Icon name="download" /> Descargar AttachedDocument
      </Button>
      <br />
      <br />
      <div style={{ overflowX: "scroll" }}>
        {xml === null ? <div className="noPdfDiv"> 
              <span>El documento no tiene un XML asociado</span>
            </div> : <XMLViewer xml={xml} />}
      </div>
    </div>
  );
};

export default observer(XML);
